import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ConfiguratorIntegrations } from '@models';
import { GetIntegrationsParams } from './service';

export enum GetIntegrationsActions {
  Failure = '[Configurator GetIntegrations] Failure',
  Request = '[Configurator GetIntegrations] Request',
  Success = '[Configurator GetIntegrations] Success',
}

export const GetIntegrationsFailure = createAction(
  GetIntegrationsActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const GetIntegrationsRequest = createAction(
  GetIntegrationsActions.Request,
  props<{ parameters?: GetIntegrationsParams }>()
);

export const GetIntegrationsSuccess = createAction(
  GetIntegrationsActions.Success,
  props<{ data: ConfiguratorIntegrations }>()
);
